import React, {useEffect, useState} from 'react';
import ModalContainer from "../../common/modal_container";
import Btn from "../../layout/Btn";
import Input from "../../layout/Input";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUser} from "@fortawesome/free-regular-svg-icons";
import {faCoins, faLock, faMoneyBill, faThumbsUp, faWifi} from "@fortawesome/free-solid-svg-icons";
import { Logo_1, Logo_2 } from '../../common/logo';

function RegisterPopup({title}: {title: string}) {
    const [registerPopShow, setRegisterPopShow] = useState<boolean>(false)

    return (
        <>
            <Btn className={"register"} onClick={e=>setRegisterPopShow(true)}>{title}</Btn>
            <RegisterModal registerPopShow={registerPopShow}
                           setRegisterPopShow={setRegisterPopShow}
                           title={title}/>
        </>
    );
}

export default RegisterPopup;

export function RegisterModal({registerPopShow, setRegisterPopShow, title}: {registerPopShow: boolean; setRegisterPopShow: Function; title: string}){
    return (
        <ModalContainer show={registerPopShow}
                        setShow={setRegisterPopShow}
                        closeBtn
                        className={'register-pop'}
        >
            <main>
                <header className={'register-header'}>
                    <p>회원가입</p>
                    <Logo_2 />
                </header>

                <FormTable/>
            </main>
        </ModalContainer>
    )
}

function FormTable(){
    const [id, setId] = useState<boolean>(false)
    const [nickname, setNickname] = useState<boolean>(false)
    const [phoneNumber, setPhoneNumber] = useState<boolean>(false)
    const [password, setPassword] = useState<boolean>(false)
    const [passwordConfirm, setPasswordConfirm] = useState<boolean>(false)

    const [formCheck, setFormCheck] = useState<boolean>(false)

    useEffect(()=> {
        let error: boolean = true
            if(!id){
                error = false
            }else if(!nickname){
                error = false
            }else if(!phoneNumber){
                error = false
            }else if(!password){
                error = false
            }else if(!passwordConfirm){
                error = false
            }
        setFormCheck(error)
        }, [id,
        nickname,
        phoneNumber,
        password,
        passwordConfirm])
    return (
        <>
            <div className={'register-table'}>
                <div className={'table'}>
                    <div>
                        <div className={'head'}>ID*</div>
                        <div className={'cell'}>
                            <Input type={'text'}
                                   name={"id"}
                                   maxLength={10}
                                   onKeyUpCapture={e=> {
                                       if(e.currentTarget.value){
                                           setId(true)
                                       }else{
                                           setId(false)
                                       }
                                   }}
                                   placeholder={'영문, 숫자 포함 4~10 글자'}/>
                        </div>
                    </div>
                    {/****************************************************************/}
                    <div>
                        <div className={'head'}>닉네임*</div>
                        <div className={'cell'}>
                            <Input type={'text'}
                                   name={"nickname"}
                                   maxLength={10}
                                   onKeyUpCapture={e=> {
                                       if(e.currentTarget.value){
                                           setNickname(true)
                                       }else{
                                           setNickname(false)
                                       }
                                   }}
                                   placeholder={'닉네임 (10자 이하)'}/>
                        </div>
                    </div>
                    {/****************************************************************/}
                    <div>
                        <div className={'head'}>휴대폰 번호*</div>
                        <div className={'cell'}>
                            <Input name={"phone_number"}
                                   onKeyUpCapture={e=> {
                                       if(e.currentTarget.value){
                                           setPhoneNumber(true)
                                       }else{
                                           setPhoneNumber(false)
                                       }
                                   }}
                                   checkPattern={/[^0-9]/gm}
                                   placeholder={'숫자만 입력'}/>
                        </div></div>
                    {/****************************************************************/}
                    <div className={'empty'}>
                        <div className={'head'}></div>
                        <div className={'cell'}></div>
                    </div>
                    {/****************************************************************/}
                    <div>
                        <div className={'head'}>비밀번호*</div>
                        <div className={'cell'}>
                            <Input type={'password'}
                                   name={"password"}
                                   minLength={6}
                                   onKeyUpCapture={e=> {
                                       if(e.currentTarget.value){
                                           setPassword(true)
                                       }else{
                                           setPassword(false)
                                       }
                                   }}
                                   placeholder={'비밀번호'}/>
                        </div>
                    </div>
                    {/****************************************************************/}
                    <div>
                        <div className={'head'}>비밀번호 확인*</div>
                        <div className={'cell'}>
                            <Input type={'password'}
                                   name={"password_confirm"}
                                   minLength={6}
                                   onKeyUpCapture={e=> {
                                       if(e.currentTarget.value){
                                           setPasswordConfirm(true)
                                       }else{
                                           setPasswordConfirm(false)
                                       }
                                   }}
                                   placeholder={'비밀번호 확인'}/>
                        </div>
                    </div>
                    {/****************************************************************/}
                    <div>
                        <div className={'head'}>출금은행</div>
                        <div className={'cell'}>
                            <Input type={'password'}
                                   name={"bank_name"}
                                   placeholder={''}/>
                        </div>
                    </div>
                    {/****************************************************************/}
                    <div>
                        <div className={'head'}>예금주</div>
                        <div className={'cell'}>
                            <Input type={'text'}
                                   name={"bank_owner"}
                                   placeholder={'예금주 (변경불가)'}/>
                        </div>
                    </div>
                    {/****************************************************************/}
                    <div>
                        <div className={'head'}>출금 계좌번호</div>
                        <div className={'cell'}>
                            <Input type={'text'}
                                   name={"bank_number"}
                                   checkPattern={/[^0-9]/gm}
                                   placeholder={'숫자만 입력'}/>
                        </div>
                    </div>
                    {/****************************************************************/}
                    <div>
                        <div className={'head'}>출금 비밀번호</div>
                        <div className={'cell'}>
                            <Input type={'password'}
                                   name={"bank_password"}
                                   placeholder={'출금비밀번호'}/>
                        </div>
                    </div>
                    {/****************************************************************/}
                    <div>
                        <div className={'head'}>추천인</div>
                        <div className={'cell'}>
                            <Input type={'text'}
                                   name={"recommend"}
                                   placeholder={'추천인 없으면 공백'}/>
                        </div>
                    </div>
                </div>
            </div>

            <div className={"btn-area"}>
                <Btn className={`${formCheck ? '' : 'disabled'}`} type={`submit`}>회원가입</Btn>
            </div>
        </>
    )
}